import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import { Modal} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classname from  './SuccessAnimated.module.scss';

const WIDTH = 300;
const styles = theme => ({
    paper: {
        padding: '0px',
        position: 'absolute',
        width: `${WIDTH}px`,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        outline: 'none',
        left: `calc(50% - ${WIDTH / 2}px)`,
        top: 'calc(50% - 150px)',
        minHeight: 200,
        borderRadius: 6
    },
    closeIcon:{
        position: 'absolute',
        right: 20,
        top: 20,
        color: '#545454'
    },
    textContainer:{
        margin: 24,
    },
});

const SuccesAnimated = (props) => {
    const { classes, open, handleClose, children, type} = props;
    const succesIcon = (	
    <div className={clsx(classname.modalIcon, classname.modalSuccess, classname.animate)}>
        <span className={clsx(classname.modalLine, classname.modalTip, classname.animateSuccessTip)}/>
        <span className={clsx(classname.modalLine, classname.modalLong, classname.animateSuccessLong)}/>
        <div className={clsx(classname.modalPlaceholder)}/>
        <div className={clsx(classname.modalFix)}/>
    </div>)
    const warningIcon = (
    <div className={clsx(classname.modalIcon, classname.modalWarning, classname.scaleWarning)}>
        <span className={clsx(classname.modalWarningBody, classname.pulseWarningIns)}/>
        <span className={clsx(classname.modalWarningDot, classname.pulseWarningIns)}/>
    </div>)
    const errorIcon = (	
    <div className={clsx(classname.modalIcon, classname.modalError, classname.animate)}>
        <span className={classname.modalXmark}>
            <span className={clsx(classname.modalLine, classname.modalLeft, classname.animateXLeft)} />
            <span className={clsx(classname.modalLine, classname.modalRight, classname.animateXRight)} />
        </span>
        <div className={classname.modalPlaceholder} />
        <div className={classname.modalFix} />
    </div>)
    let icon  = ''

    switch (type) {
        case 'success':
            icon =  succesIcon;
            break;
        case 'error':
            icon =  errorIcon;
            break;
        case 'warning':
            icon =  warningIcon;
            break;
        default:
            icon =  '';
    }

    return (
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={open}
            onClose={handleClose}
        >
            <div className={classes.paper}>
                {icon}
                <FontAwesomeIcon onClick={handleClose} className={classes.closeIcon} icon={['fas', 'times']} />
                <div className={classes.textContainer}>
                    {children}
                </div>
            </div>
        </Modal>
    );
}

export default withStyles(styles)(SuccesAnimated);